(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8526,9381,9219,4678,1468,2820],{

/***/ 44020:
/***/ (function(module) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return [decodeURIComponent(components.join(''))];
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher) || [];

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher) || [];
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),

/***/ 92806:
/***/ (function(module) {

"use strict";

module.exports = function (obj, predicate) {
	var ret = {};
	var keys = Object.keys(obj);
	var isArr = Array.isArray(predicate);

	for (var i = 0; i < keys.length; i++) {
		var key = keys[i];
		var val = obj[key];

		if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
			ret[key] = val;
		}
	}

	return ret;
};


/***/ }),

/***/ 24100:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/defaultpic.119a8e64.webp","height":269,"width":264,"blurDataURL":"data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoIAAgAAkA4JaQAA3AA/vgQAAA=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 38526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ header_Search_Search; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(26628);
// EXTERNAL MODULE: ./svg/index.js
var svg = __webpack_require__(69587);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/shared/AsyncAction.ts
var AsyncAction = __webpack_require__(89381);
// EXTERNAL MODULE: ./store/cart/index.js + 3 modules
var cart = __webpack_require__(28286);
// EXTERNAL MODULE: ./services/utils.js
var utils = __webpack_require__(75681);
// EXTERNAL MODULE: ./components/shared/Currency.tsx
var Currency = __webpack_require__(19219);
// EXTERNAL MODULE: ./images/defaultpic.webp
var defaultpic = __webpack_require__(24100);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./store/general/index.ts + 3 modules
var general = __webpack_require__(26298);
// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__(63385);
// EXTERNAL MODULE: ./components/shared/InStockProducts.tsx
var InStockProducts = __webpack_require__(34678);
// EXTERNAL MODULE: ./components/header/Search/search.module.scss
var search_module = __webpack_require__(86443);
var search_module_default = /*#__PURE__*/__webpack_require__.n(search_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/header/Search/Suggestions.tsx

















//@ts-ignore
function Suggestions(props) {
    var context = props.context, className = props.className, products = props.products;
    var rootClasses = classnames_default()("".concat((search_module_default()).suggestions, " ").concat((search_module_default())["suggestions--location--".concat(context)]), className);
    var dispatch = (0,es/* useDispatch */.I0)();
    var cartToken = (0,es/* useSelector */.v9)(function(state) {
        return state.cartToken;
    });
    var customer = (0,es/* useSelector */.v9)(function(state) {
        return state.customer;
    });
    // const apiToken = useSelector((state: IState) => state.general.apiToken)
    var backorders = (0,es/* useSelector */.v9)(function(state) {
        return state.general.Backorders;
    });
    var outOfStock = Boolean(+(0,es/* useSelector */.v9)(function(state) {
        var ref;
        return (ref = state.general.coreConfigs.catalog_products_homepage_out_of_stock_items) === null || ref === void 0 ? void 0 : ref.value;
    }));
    var rate = (0,es/* useSelector */.v9)(function(state) {
        return state.rate.exchange_rate.rate;
    });
    var selectedData = (0,es/* useSelector */.v9)(function(state) {
        return state.locale.code;
    });
    var currency = (0,es/* useSelector */.v9)(function(state) {
        return state.rate.current.code;
    });
    //@ts-ignore
    var openUpCrossProd = function(product) {
        var hasUpSell = (product === null || product === void 0 ? void 0 : product.product_flat[0].has_up_sell) == 1;
        var hasCrossSell = (product === null || product === void 0 ? void 0 : product.product_flat[0].has_cross_sell) == 1;
        var page = true;
        if (!hasUpSell && hasCrossSell) {
            dispatch((0,cart/* getUpOrCrossProd */.xM)(product.id, "crossSell", selectedData, currency, rate, page));
            dispatch((0,general/* setPopupName */.Sq)("crossSell"));
        }
        if (hasUpSell) {
            dispatch((0,general/* setPopupName */.Sq)("upsell"));
            dispatch((0,cart/* getUpOrCrossProd */.xM)(product.id, "upSell", selectedData, currency, rate, page));
        }
    };
    var isProductInStock = function(product) {
        var ref;
        var qty = (ref = product === null || product === void 0 ? void 0 : product.product_inventories[0]) === null || ref === void 0 ? void 0 : ref.qty;
        return Number(qty) > 0 || Number(qty) === 0 && backorders;
    };
    // useEffect(() => {
    //   ///setToken(apiToken);
    //   fetch(apiUrlWithStore('/api/checkout/cart/token'))
    //     .then((responce) => responce.json())
    //     .then((res) => {
    //       setToken(res)
    //     })
    //     .catch((err) => console.error(err))
    // }, [apiToken])
    var list = products && //@ts-ignore
    products.map(function(product) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
        return product.id != -1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InStockProducts["default"], {
            qty: (ref = product === null || product === void 0 ? void 0 : product.product_inventories[0]) === null || ref === void 0 ? void 0 : ref.qty,
            stockID: "no_matching_items",
            stockValue: "No matching items",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                className: (search_module_default()).suggestions__item,
                children: [
                    (product === null || product === void 0 ? void 0 : product.product_images) && (product === null || product === void 0 ? void 0 : (ref1 = product.product_images) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((search_module_default())["suggestions__item-image"], " ").concat((search_module_default())["product-image"]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((search_module_default())["search-product-image__body-fms"]),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: (0,helper/* domainUrl */.HJ)("".concat(props.dbName, "/storage/").concat((ref2 = product === null || product === void 0 ? void 0 : product.product_images[0]) === null || ref2 === void 0 ? void 0 : ref2.path)),
                                alt: (ref3 = product === null || product === void 0 ? void 0 : product.product_flat[0]) === null || ref3 === void 0 ? void 0 : ref3.name,
                                placeholder: "blur",
                                width: 50,
                                height: 50,
                                priority: true,
                                blurDataURL: "/zega/blur1.webp"
                            })
                        })
                    }) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((search_module_default())["suggestions__item-image"], " ").concat((search_module_default())["product-image"]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((search_module_default())["search-product-image__body-fms"]),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: utils/* url.product */.HQ.product(product),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: (0,helper/* domainUrl */.HJ)("".concat(props.dbName, "/storage/").concat((ref4 = product === null || product === void 0 ? void 0 : product.product_images[0]) === null || ref4 === void 0 ? void 0 : ref4.path)),
                                        alt: (ref5 = product === null || product === void 0 ? void 0 : product.product_flat[0]) === null || ref5 === void 0 ? void 0 : ref5.name,
                                        placeholder: "blur",
                                        width: 50,
                                        height: 50,
                                        priority: true,
                                        blurDataURL: "/zega/blur1.webp"
                                    })
                                })
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((search_module_default())["suggestions__item-image"], " ").concat((search_module_default())["product-image"]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((search_module_default())["search-product-image__body-fms"]),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: (0,helper/* domainUrl */.HJ)("".concat(props.dbName).concat(defaultpic/* default.src */.Z.src)),
                                alt: (ref6 = product === null || product === void 0 ? void 0 : product.product_flat[0]) === null || ref6 === void 0 ? void 0 : ref6.name,
                                placeholder: "blur",
                                width: 50,
                                height: 50,
                                priority: true,
                                blurDataURL: "/zega/blur1.webp"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (search_module_default())["suggestions__item-info"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    className: (search_module_default())["suggestions__item-name"],
                                    href: utils/* url.product */.HQ.product(product),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        children: [
                                            " ",
                                            (ref7 = product === null || product === void 0 ? void 0 : product.product_flat[0]) === null || ref7 === void 0 ? void 0 : ref7.name
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    //@ts-ignore
                                    className: (search_module_default())["suggestions__item-meta"],
                                    children: [
                                        (ref10 = (ref8 = product === null || product === void 0 ? void 0 : product.sku_option[0]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.translations) === null || ref9 === void 0 ? void 0 : ref9.find(function(el) {
                                            return el.locale === selectedData;
                                        })) === null || ref10 === void 0 ? void 0 : ref10.name,
                                        ": ",
                                        (ref11 = product === null || product === void 0 ? void 0 : product.product_flat[0]) === null || ref11 === void 0 ? void 0 : ref11.sku
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (search_module_default())["suggestions__item-price"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Currency["default"], {
                                value: product.special_price ? product.special_price : product.price || Number(product === null || product === void 0 ? void 0 : product.min_price).toFixed(2)
                            }),
                            " "
                        ]
                    }),
                    context === "header" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("".concat((search_module_default())["suggestions__item-actions"]), ((ref12 = product === null || product === void 0 ? void 0 : product.product_inventories[0]) === null || ref12 === void 0 ? void 0 : ref12.qty) === 0 && backorders == 0 && !outOfStock && (search_module_default()).button_disabled),
                        children: product && (product === null || product === void 0 ? void 0 : product.type) === "configurable" || (product === null || product === void 0 ? void 0 : product.type) === "bundle" || !isProductInStock(product) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: utils/* url.product */.HQ.product(product),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: classnames_default()("btn btn-primary btn-sm btn-svg-icon ".concat((search_module_default())["suggestion-btn"]), {
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* Cart16Svg */.Jz, {})
                                })
                            })
                        }) : product.product_flat[0].has_up_sell == 0 && product.product_flat[0].has_cross_sell == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AsyncAction["default"], {
                            //@ts-ignore
                            action: function() {
                                return dispatch((0,cart/* cartAddItem */.rg)(product, [], 1, cartToken, customer, selectedData, null, "homePage"));
                            },
                            //@ts-ignore
                            render: function(param) {
                                var run = param.run, loading = param.loading;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    onClick: function(e) {
                                        e.preventDefault();
                                        dispatch((0,general/* setCrossValid */.TV)(false));
                                        run();
                                    },
                                    className: classnames_default()("btn btn-primary btn-sm btn-svg-icon ".concat((search_module_default())["suggestion-btn"]), {
                                        "btn-loading": loading
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* Cart16Svg */.Jz, {})
                                });
                            }
                        }) : product.product_flat[0].has_up_sell == 0 && product.product_flat[0].has_cross_sell == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AsyncAction["default"], {
                            //@ts-ignore
                            action: function() {
                                return dispatch((0,cart/* cartAddItem */.rg)(product, [], 1, cartToken, customer, selectedData, null, "homePage"));
                            },
                            //@ts-ignore
                            render: function(param) {
                                var run = param.run, loading = param.loading;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    onClick: function(e) {
                                        e.preventDefault();
                                        run();
                                        dispatch((0,general/* setTempData */.LH)([
                                            product
                                        ]));
                                        dispatch((0,general/* setCrossValid */.TV)(true));
                                        openUpCrossProd(product);
                                    },
                                    className: classnames_default()("btn btn-primary btn-sm btn-svg-icon ".concat((search_module_default())["suggestion-btn"]), {
                                        "btn-loading": loading
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* Cart16Svg */.Jz, {})
                                });
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AsyncAction["default"], {
                            //@ts-ignore
                            render: function(param) {
                                var run = param.run, loading = param.loading;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    onClick: function(e) {
                                        e.preventDefault();
                                        run();
                                        dispatch((0,general/* setTempData */.LH)([
                                            product
                                        ]));
                                        dispatch((0,general/* setCrossValid */.TV)(false));
                                        openUpCrossProd(product);
                                    },
                                    className: classnames_default()("btn btn-primary btn-sm btn-svg-icon ".concat((search_module_default())["suggestion-btn"]), {
                                        "btn-loading": loading
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* Cart16Svg */.Jz, {})
                                });
                            }
                        })
                    })
                ]
            })
        }, (ref13 = product === null || product === void 0 ? void 0 : product.product_flat[0]) === null || ref13 === void 0 ? void 0 : ref13.product_id) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (search_module_default()).search__fm_dr_Message,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "no_matching_items",
                defaultMessage: "No matching items"
            })
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: rootClasses,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: (search_module_default()).suggestions__list,
            children: list
        })
    });
}
/* harmony default export */ var Search_Suggestions = (Suggestions);

// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
;// CONCATENATED MODULE: ./components/header/Search/index.tsx







var SearchComponent = function(param) {
    var setQuery = param.setQuery, cancelFn = param.cancelFn, wrapper = param.wrapper, handleFocus = param.handleFocus, handleKeyDown = param.handleKeyDown, suggestedProducts = param.suggestedProducts, handleSearchButt = param.handleSearchButt, closeButton = param.closeButton, query = param.query, handleChangeQuery = param.handleChangeQuery, close = param.close;
    var history = (0,router.useRouter)();
    var location = history.asPath;
    (0,react.useEffect)(function() {
        var search = query_string.parse(window.location.search).search;
        if (search) {
            setQuery(search);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        location
    ]);
    (0,react.useEffect)(function() {
        return close();
    }, [
        close,
        location
    ]);
    (0,react.useEffect)(function() {
        var onGlobalClick = function(event) {
            if (wrapper.current && !wrapper.current.contains(event.target)) {
                close();
            }
        };
        document.addEventListener("mousedown", onGlobalClick);
        return function() {
            return document.removeEventListener("mousedown", onGlobalClick);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        close
    ]);
    // Cancel previous typing.
    (0,react.useEffect)(function() {
        return function() {
            return cancelFn();
        };
    }, [
        cancelFn
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (search_module_default()).search__form,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "search_looking_for",
                defaultMessage: "I am looking for․․.",
                children: function(placeholder) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        onChange: handleChangeQuery,
                        onFocus: handleFocus,
                        onKeyDown: handleKeyDown,
                        value: query_string.parse(location.search).search || query,
                        className: (search_module_default()).search__input,
                        name: "search",
                        placeholder: placeholder,
                        "aria-label": "Site search",
                        type: "text",
                        autoComplete: "off"
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "".concat((search_module_default()).search__button, " ").concat((search_module_default())["search__button--type--submit"]),
                "aria-label": "Search",
                onClick: function() {
                    if (suggestedProducts[0]) {
                        if (suggestedProducts[0].id != -1) {
                            handleSearchButt();
                            setQuery("");
                        }
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* SearchssSvg */.n8, {})
            }),
            closeButton,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (search_module_default()).search__border
            })
        ]
    });
};
/* harmony default export */ var Search = (/*#__PURE__*/(0,react.memo)(SearchComponent));

// EXTERNAL MODULE: ./api/shop.ts
var shop = __webpack_require__(9383);
;// CONCATENATED MODULE: ./components/header/Search/Search.tsx










function Search_Search(props) {
    var context = props.context, className = props.className, onClose = props.onClose;
    var history = (0,router.useRouter)();
    var ref = (0,react.useState)(""), query = ref[0], setQuery = ref[1];
    var ref1 = (0,react.useState)(function() {
        return function() {};
    }), cancelFn = ref1[0], setCancelFn = ref1[1];
    var ref2 = (0,react.useState)(false), suggestionsOpen = ref2[0], setSuggestionsOpen = ref2[1];
    var ref3 = (0,react.useState)(false), hasSuggestions = ref3[0], setHasSuggestions = ref3[1];
    var ref4 = (0,react.useState)([]), suggestedProducts = ref4[0], setSuggestedProducts = ref4[1];
    var selectedData = (0,es/* useSelector */.v9)(function(state) {
        return state.locale.code;
    });
    var dbName = (0,es/* useSelector */.v9)(function(state) {
        return state.general.dbName;
    });
    var searchOpen = (0,es/* useSelector */.v9)(function(state) {
        return state.mobileMenu.searchOpen;
    });
    // useEffect(() => {
    //     if(searchOpen){
    //         document.body.style.overflowY = "hidden"
    //     }else document.body.style.overflowY = "scroll"
    // }, [searchOpen])
    var wrapper = (0,react.useRef)(null);
    var close = (0,react.useCallback)(function() {
        if (onClose) {
            onClose();
        }
        setSuggestionsOpen(false);
    }, []);
    var handleFocus = function() {
        setSuggestionsOpen(true);
    };
    var handleChangeQuery = (0,react.useCallback)(function(event) {
        var canceled = false;
        var timer;
        var newCancelFn = function() {
            canceled = true;
            clearTimeout(timer);
        };
        var query = event.target.value;
        setQuery(query);
        if (query.length >= 3) {
            timer = setTimeout(function() {
                var options = {
                    limit: 10,
                    lang: selectedData,
                    dbName: props.dbName,
                    category: ""
                };
                shop/* default.getSeachProducts */.Z.getSeachProducts({
                    query: query,
                    options: options
                }).then(function(products) {
                    var ref;
                    if (canceled) {
                        return;
                    }
                    var newProduct = products === null || products === void 0 ? void 0 : (ref = products.data) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
                        if (item.length === 0) {
                            return;
                        }
                        return item;
                    });
                    if ((newProduct === null || newProduct === void 0 ? void 0 : newProduct.length) > 0) {
                        setSuggestedProducts(newProduct);
                        setHasSuggestions(newProduct.length > 0);
                        setSuggestionsOpen(true);
                    } else {
                        setSuggestedProducts([
                            {
                                id: -1
                            }
                        ]);
                        setHasSuggestions((newProduct === null || newProduct === void 0 ? void 0 : newProduct.length) == 0);
                        setSuggestionsOpen(true);
                    }
                });
            }, 1000);
        }
        if (query === "") {
            setHasSuggestions(false);
        }
        setCancelFn(function() {
            return newCancelFn;
        });
    }, [
        props.dbName,
        selectedData
    ]);
    var handleBlur = (0,react.useCallback)(function() {
        setTimeout(function() {
            if (!document.activeElement || document.activeElement === document.body) {
                return;
            }
            // Close suggestions if the focus received an external element.
            if (wrapper.current && !wrapper.current.contains(document.activeElement)) {
                close();
            }
        }, 10);
    }, [
        close
    ]);
    // Close suggestions when the Escape key has been pressed.
    var handleKeyDown = (0,react.useCallback)(function(event) {
        // Escape.
        if (event.which === 27) {
            close();
        }
        if (event.which == 13 && query.length > 0) {
            event.preventDefault();
            localStorage.setItem("searchProductsFm", JSON.stringify(suggestedProducts));
            history.push({
                pathname: "/catalog/search/".concat(query)
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        history,
        query,
        suggestedProducts
    ]);
    var handleSearchButt = (0,react.useCallback)(function() {
        if (query.length > 0) {
            localStorage.setItem("searchProductsFm", JSON.stringify(suggestedProducts));
            history.push({
                pathname: "/catalog/search/" + query
            });
        }
    }, []);
    var rootClasses = classnames_default()("".concat((search_module_default()).search, " ").concat((search_module_default())["search--location--".concat(context)]), className, suggestionsOpen && (search_module_default())["search--suggestions-open"], hasSuggestions && (search_module_default())["search--has-suggestions"]);
    var closeButton = (0,react.useMemo)(function() {
        if (context === "mobile-header") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "".concat((search_module_default()).search__button, " ").concat((search_module_default())["search__button--type--close"]),
                type: "button",
                onClick: close,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* Cross20Svg */.He, {})
            });
        }
        return "";
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        context
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: rootClasses,
        ref: wrapper,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (search_module_default()).search__body,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Search, {
                    cancelFn: cancelFn,
                    setQuery: setQuery,
                    wrapper: wrapper,
                    handleFocus: handleFocus,
                    handleKeyDown: handleKeyDown,
                    suggestedProducts: suggestedProducts,
                    handleSearchButt: handleSearchButt,
                    closeButton: closeButton,
                    query: query,
                    handleChangeQuery: handleChangeQuery,
                    close: close
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_Suggestions, {
                    className: (search_module_default()).search__suggestions,
                    context: context,
                    products: suggestedProducts,
                    setQuery: setQuery,
                    dbName: dbName
                })
            ]
        })
    });
}
/* harmony default export */ var header_Search_Search = (Search_Search);


/***/ }),

/***/ 89381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var AsyncAction = function(param) {
    var action = param.action, render = param.render;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), loading = ref[0], setLoading = ref[1];
    var canceled = false;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        return function() {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            canceled = true;
        };
    }, []);
    var run = function() {
        var //@ts-ignore
        ref;
        if (loading || !action) {
            return;
        }
        setLoading(true);
        (ref = action()) === null || ref === void 0 ? void 0 : ref.then(function() {
            if (canceled) {
                return;
            }
            setLoading(false);
        });
    };
    return render({
        run: run,
        loading: loading
    });
};
/* harmony default export */ __webpack_exports__["default"] = (AsyncAction);


/***/ }),

/***/ 19219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26628);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12820);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_shared_module_scss__WEBPACK_IMPORTED_MODULE_3__);




function Currency(param) {
    var value = param.value;
    var locale = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.locale.code;
    });
    var symbol = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.rate.current.symbol;
    });
    value = value + "";
    var removeUpTo6Zeros = function(val) {
        var i;
        for(i = 0; i < 6; i++){
            if (val[val.length - 1 - i] !== "0") break;
        }
        return i ? val.slice(0, -i) : val;
    };
    var valueArray = value ? value === null || value === void 0 ? void 0 : value.split(".") : "";
    if (valueArray[1]) {
        var valueAfterDot = removeUpTo6Zeros(valueArray[1]);
        if (valueAfterDot) {
            value = [
                valueArray[0],
                valueAfterDot
            ].join(".");
        } else {
            value = valueArray[0];
        }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_3___default().currency_value),
        children: locale === "hy" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: "".concat(value)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: symbol
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: symbol
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: "".concat(value)
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Currency);


/***/ }),

/***/ 34678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26628);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44012);




var InStockProducts = function(param) {
    var children = param.children, qty = param.qty, stockID = param.stockID, stockValue = param.stockValue;
    var outOfStock = Boolean(+(0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        var ref;
        return (ref = state.general.coreConfigs.catalog_products_homepage_out_of_stock_items) === null || ref === void 0 ? void 0 : ref.value;
    }));
    var value = stockID && stockValue ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "search__fm_dr_Message",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            id: stockID,
            defaultMessage: stockValue
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: !outOfStock && qty === 0 ? value : children
    });
};
/* harmony default export */ __webpack_exports__["default"] = (InStockProducts);


/***/ }),

/***/ 86443:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"search--location--indicator":"search_search--location--indicator__By7pL","search__body":"search_search__body__m_Ei8","search__form":"search_search__form__6P6SS","search__suggestions":"search_search__suggestions__ePryK","search__input":"search_search__input__0rWHP","search__button":"search_search__button__YCJ_T","search--has-suggestions":"search_search--has-suggestions__n2Fps","search--suggestions-open":"search_search--suggestions-open__rGHTX","search--location--header":"search_search--location--header__Gry40","search__border":"search_search__border__daq6t","search--location--mobile-header":"search_search--location--mobile-header__g2iuL","suggestions--location--header":"search_suggestions--location--header__HjqWG","suggestions__item":"search_suggestions__item__yXAJ5","suggestions__item-meta":"search_suggestions__item-meta__NFw9v","suggestions--location--indicator":"search_suggestions--location--indicator__koAgu","suggestions__item-actions":"search_suggestions__item-actions__YZUAi","suggestions--location--mobile-header":"search_suggestions--location--mobile-header__WgxuK","suggestions__list":"search_suggestions__list__IMfhB","search__fm_dr_Message":"search_search__fm_dr_Message__DNfi3","suggestions__item-image":"search_suggestions__item-image__0Jx45","suggestions__item-info":"search_suggestions__item-info__mOmQc","suggestions__item-name":"search_suggestions__item-name__giEsp","suggestions__item-price":"search_suggestions__item-price__o7FSC","suggestion-btn":"search_suggestion-btn__ZmJUm","search__button--type--close":"search_search__button--type--close__2f7lI","search__button--type--submit":"search_search__button--type--submit__waeRt","background_layer":"search_background_layer__QVKuF"};

/***/ }),

/***/ 12820:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text-success":"shared_text-success__b_GSc","text-danger":"shared_text-danger__uaRO3","product__prices":"shared_product__prices__CVW7b","color-lightgray":"shared_color-lightgray__tr4MM","product-card__new-price":"shared_product-card__new-price__Uh_wK","product-card__new-price_old_value":"shared_product-card__new-price_old_value__lZEg1","product-card__old-price":"shared_product-card__old-price__qVzw5","test":"shared_test__XJFgh","slick-prevent-click":"shared_slick-prevent-click__46Rz_","product-gallery__carousel":"shared_product-gallery__carousel__rweRi","slick-list":"shared_slick-list__Qm8q0","slick-track":"shared_slick-track__e1on5","product__gallery":"shared_product__gallery__2Qcoo","product-gallery__featured":"shared_product-gallery__featured__7qvkg","product-image__body":"shared_product-image__body___pMPQ","product-image":"shared_product-image__RGE_Z","product-gallery__zoom":"shared_product-gallery__zoom__zE4Rt","product-gallery__carousel-item":"shared_product-gallery__carousel-item__YOaGt","product-image--location--gallery":"shared_product-image--location--gallery__mX462","product-image__img":"shared_product-image__img__7FiK4","owl-carousel":"shared_owl-carousel__DZ_qV","owl-item":"shared_owl-item__1Ipyt","product-gallery__carousel-item--active":"shared_product-gallery__carousel-item--active__Y6uRZ","small-img-car_fms":"shared_small-img-car_fms__trqT1","product-small-img":"shared_product-small-img__19vI8","currency_value":"shared_currency_value__5IPjM","block-header":"shared_block-header__Y47R6","block-header__title":"shared_block-header__title__fNPSo","block-header__divider":"shared_block-header__divider__z_Ltc","block-header__groups-list":"shared_block-header__groups-list__Lcx3T","block-header__title__custom":"shared_block-header__title__custom__sD_wp","title-line-fms":"shared_title-line-fms__G_D1_","title-name-fms":"shared_title-name-fms__dTBlZ","block-header__group":"shared_block-header__group__wwwXx","block-header__group--active":"shared_block-header__group--active__Fl3KN","block-header__arrows-list":"shared_block-header__arrows-list__Acux7","block-header__arrow":"shared_block-header__arrow__IeFTb","block-header__arrow--left":"shared_block-header__arrow--left__UKyJW","block-header__arrow--right":"shared_block-header__arrow--right__KMu9G","breadcrumb":"shared_breadcrumb___jX19","input-number":"shared_input-number__mS_oj","minus_hide":"shared_minus_hide__G0BFC","input-number__input":"shared_input-number__input__pZxDP","input-number__sub":"shared_input-number__sub__8I6_b","input-number__add":"shared_input-number__add__0lk8a","form-control-sm":"shared_form-control-sm__fiyvR","product__quantity":"shared_product__quantity__j3dv_","cart-quantity-responsive":"shared_cart-quantity-responsive__5_4kx","page-header":"shared_page-header__36R5E","breadcrumb-item":"shared_breadcrumb-item__0qre7","breadcrumb-item-active":"shared_breadcrumb-item-active__V3KYS","page-header__breadcrumb":"shared_page-header__breadcrumb__i_Z7a","page-header__title":"shared_page-header__title__JaRFr","breadcrumb-arrow":"shared_breadcrumb-arrow__uQK9o","page-header__container":"shared_page-header__container__mEt_Q","pagination":"shared_pagination__bdXo7","sr-only":"shared_sr-only__9FqOD","page-link":"shared_page-link__CMUmq","page-link--with-arrow":"shared_page-link--with-arrow__c1IUc","page-link__arrow":"shared_page-link__arrow__mULrQ","page-link__arrow--left":"shared_page-link__arrow--left___61oN","page-link__arrow--right":"shared_page-link__arrow--right__k9sB2","page-item":"shared_page-item__dpA_F","page-item-disabled":"shared_page-item-disabled__DERIG","page-item-active":"shared_page-item-active__MPK7e","bottomNavigation-wrapper":"shared_bottomNavigation-wrapper__qch5s","indicatpr_area":"shared_indicatpr_area__8uOGn","bottom-nav-item--title":"shared_bottom-nav-item--title__vcuz0","bottom-nav-item--title-active":"shared_bottom-nav-item--title-active__XLHhd","local-item":"shared_local-item__lM6aT","local-item-active":"shared_local-item-active__SLCm2","active":"shared_active__9Ifpg","bottom-nav-item":"shared_bottom-nav-item__O_XHs","bottom-nav":"shared_bottom-nav__H2kJw","indicator__value":"shared_indicator__value__WOLbt","indicator":"shared_indicator__H_FQK","false":"shared_false___CPLZ","indicator__area":"shared_indicator__area__th4gv","mob_area":"shared_mob_area___TbbM","block-posts":"shared_block-posts___KdlJ","slick-slide":"shared_slick-slide__A6TQC","post-card":"shared_post-card__iG54_","block-posts--layout--list-sm":"shared_block-posts--layout--list-sm__U1MbP","post-card__image":"shared_post-card__image__7N_gj","post-card__name":"shared_post-card__name__mtEZ3","post-card__date":"shared_post-card__date__Vl_uC","post-card__category":"shared_post-card__category__tfnxa","post-card__content":"shared_post-card__content__WkHA7","post-card__read-more":"shared_post-card__read-more__8ZXB_","post-card__info":"shared_post-card__info__hGWgj","block-posts--layout--grid-nl":"shared_block-posts--layout--grid-nl__A6c3z","post-card__read-data":"shared_post-card__read-data__D4d0W","post-card--layout--related":"shared_post-card--layout--related__XefJD","post-card--layout--grid":"shared_post-card--layout--grid__e3_ld","post-card--size--lg":"shared_post-card--size--lg__x_1XA","post-card--layout--list":"shared_post-card--layout--list__wvqDN","post-card--size--nl":"shared_post-card--size--nl__AJ2H2","post-card--size--sm":"shared_post-card--size--sm__6Zwvl","social-links__list":"shared_social-links__list__dfW3w","social-links__item":"shared_social-links__item__7uXma","social-links__link":"shared_social-links__link__b_S9g","social-links--shape--circle":"shared_social-links--shape--circle__YFFEi","social-links--shape--rounded":"shared_social-links--shape--rounded__TT0YX","social-links__link--type--facebook":"shared_social-links__link--type--facebook__G719K","social-links__link--type--twitter":"shared_social-links__link--type--twitter__7ulYd","social-links__link--type--youtube":"shared_social-links__link--type--youtube__FWKHG","social-links__link--type--instagram":"shared_social-links__link--type--instagram___32Vy","social-links__link--type--rss":"shared_social-links__link--type--rss___vbZg","wishlist-circle":"shared_wishlist-circle__IHvkp","wishlist-icon-wrapper":"shared_wishlist-icon-wrapper__pW_9v","wishlist-circle-clicked":"shared_wishlist-circle-clicked__ZBHpI","inner-wishlist":"shared_inner-wishlist__S07T4","product-card__prices":"shared_product-card__prices__OXbim","uPsell-title":"shared_uPsell-title__TIb25","upsell-content":"shared_upsell-content__QoYrE","upsell_body":"shared_upsell_body__5qzyA","product__content":"shared_product__content__zHVz_","product__info":"shared_product__info__2JUdC","short_description_block":"shared_short_description_block__hIkfU","product-inner-description-title":"shared_product-inner-description-title__h9vAb","product__meta":"shared_product__meta__EwL40","product__sidebar":"shared_product__sidebar__O9bRJ","product__options":"shared_product__options__2X85W","product__actions":"shared_product__actions__dAK_0","no-thanks":"shared_no-thanks__G__wn","btn":"shared_btn__2IzVc","btn-orange":"shared_btn-orange__zc5e3","rounded-pills":"shared_rounded-pills__Z7qlr","product__name":"shared_product__name__QUTXW","ups-product__info":"shared_ups-product__info__W_YrR","product__actions-item--addToCart":"shared_product__actions-item--addToCart__dHUJi","item_overlay":"shared_item_overlay__qz1Am","product-card__image":"shared_product-card__image__IroED","product-image__default-fms":"shared_product-image__default-fms__0xjYL","cross__prods":"shared_cross__prods__xJAFI"};

/***/ }),

/***/ 17563:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

const strictUriEncode = __webpack_require__(70610);
const decodeComponent = __webpack_require__(44020);
const splitOnFirst = __webpack_require__(80500);
const filterObject = __webpack_require__(92806);

const isNullOrUndefined = value => value === null || value === undefined;

const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');

function encoderForArrayFormat(options) {
	switch (options.arrayFormat) {
		case 'index':
			return key => (result, value) => {
				const index = result.length;

				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[', index, ']'].join('')];
				}

				return [
					...result,
					[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')
				];
			};

		case 'bracket':
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[]'].join('')];
				}

				return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
			};

		case 'colon-list-separator':
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), ':list='].join('')];
				}

				return [...result, [encode(key, options), ':list=', encode(value, options)].join('')];
			};

		case 'comma':
		case 'separator':
		case 'bracket-separator': {
			const keyValueSep = options.arrayFormat === 'bracket-separator' ?
				'[]=' :
				'=';

			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				// Translate null to an empty string so that it doesn't serialize as 'null'
				value = value === null ? '' : value;

				if (result.length === 0) {
					return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
				}

				return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
			};
		}

		default:
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, encode(key, options)];
				}

				return [...result, [encode(key, options), '=', encode(value, options)].join('')];
			};
	}
}

function parserForArrayFormat(options) {
	let result;

	switch (options.arrayFormat) {
		case 'index':
			return (key, value, accumulator) => {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return (key, value, accumulator) => {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		case 'colon-list-separator':
			return (key, value, accumulator) => {
				result = /(:list)$/.exec(key);
				key = key.replace(/:list$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		case 'comma':
		case 'separator':
			return (key, value, accumulator) => {
				const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
				const isEncodedArray = (typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator));
				value = isEncodedArray ? decode(value, options) : value;
				const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : value === null ? value : decode(value, options);
				accumulator[key] = newValue;
			};

		case 'bracket-separator':
			return (key, value, accumulator) => {
				const isArray = /(\[\])$/.test(key);
				key = key.replace(/\[\]$/, '');

				if (!isArray) {
					accumulator[key] = value ? decode(value, options) : value;
					return;
				}

				const arrayValue = value === null ?
					[] :
					value.split(options.arrayFormatSeparator).map(item => decode(item, options));

				if (accumulator[key] === undefined) {
					accumulator[key] = arrayValue;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], arrayValue);
			};

		default:
			return (key, value, accumulator) => {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function validateArrayFormatSeparator(value) {
	if (typeof value !== 'string' || value.length !== 1) {
		throw new TypeError('arrayFormatSeparator must be single character string');
	}
}

function encode(value, options) {
	if (options.encode) {
		return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function decode(value, options) {
	if (options.decode) {
		return decodeComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	}

	if (typeof input === 'object') {
		return keysSorter(Object.keys(input))
			.sort((a, b) => Number(a) - Number(b))
			.map(key => input[key]);
	}

	return input;
}

function removeHash(input) {
	const hashStart = input.indexOf('#');
	if (hashStart !== -1) {
		input = input.slice(0, hashStart);
	}

	return input;
}

function getHash(url) {
	let hash = '';
	const hashStart = url.indexOf('#');
	if (hashStart !== -1) {
		hash = url.slice(hashStart);
	}

	return hash;
}

function extract(input) {
	input = removeHash(input);
	const queryStart = input.indexOf('?');
	if (queryStart === -1) {
		return '';
	}

	return input.slice(queryStart + 1);
}

function parseValue(value, options) {
	if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
		value = Number(value);
	} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
		value = value.toLowerCase() === 'true';
	}

	return value;
}

function parse(query, options) {
	options = Object.assign({
		decode: true,
		sort: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',',
		parseNumbers: false,
		parseBooleans: false
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const formatter = parserForArrayFormat(options);

	// Create an object with no prototype
	const ret = Object.create(null);

	if (typeof query !== 'string') {
		return ret;
	}

	query = query.trim().replace(/^[?#&]/, '');

	if (!query) {
		return ret;
	}

	for (const param of query.split('&')) {
		if (param === '') {
			continue;
		}

		let [key, value] = splitOnFirst(options.decode ? param.replace(/\+/g, ' ') : param, '=');

		// Missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		value = value === undefined ? null : ['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : decode(value, options);
		formatter(decode(key, options), value, ret);
	}

	for (const key of Object.keys(ret)) {
		const value = ret[key];
		if (typeof value === 'object' && value !== null) {
			for (const k of Object.keys(value)) {
				value[k] = parseValue(value[k], options);
			}
		} else {
			ret[key] = parseValue(value, options);
		}
	}

	if (options.sort === false) {
		return ret;
	}

	return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key) => {
		const value = ret[key];
		if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
			// Sort object keys, not values
			result[key] = keysSorter(value);
		} else {
			result[key] = value;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = (object, options) => {
	if (!object) {
		return '';
	}

	options = Object.assign({
		encode: true,
		strict: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ','
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const shouldFilter = key => (
		(options.skipNull && isNullOrUndefined(object[key])) ||
		(options.skipEmptyString && object[key] === '')
	);

	const formatter = encoderForArrayFormat(options);

	const objectCopy = {};

	for (const key of Object.keys(object)) {
		if (!shouldFilter(key)) {
			objectCopy[key] = object[key];
		}
	}

	const keys = Object.keys(objectCopy);

	if (options.sort !== false) {
		keys.sort(options.sort);
	}

	return keys.map(key => {
		const value = object[key];

		if (value === undefined) {
			return '';
		}

		if (value === null) {
			return encode(key, options);
		}

		if (Array.isArray(value)) {
			if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
				return encode(key, options) + '[]';
			}

			return value
				.reduce(formatter(key), [])
				.join('&');
		}

		return encode(key, options) + '=' + encode(value, options);
	}).filter(x => x.length > 0).join('&');
};

exports.parseUrl = (url, options) => {
	options = Object.assign({
		decode: true
	}, options);

	const [url_, hash] = splitOnFirst(url, '#');

	return Object.assign(
		{
			url: url_.split('?')[0] || '',
			query: parse(extract(url), options)
		},
		options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: decode(hash, options)} : {}
	);
};

exports.stringifyUrl = (object, options) => {
	options = Object.assign({
		encode: true,
		strict: true,
		[encodeFragmentIdentifier]: true
	}, options);

	const url = removeHash(object.url).split('?')[0] || '';
	const queryFromUrl = exports.extract(object.url);
	const parsedQueryFromUrl = exports.parse(queryFromUrl, {sort: false});

	const query = Object.assign(parsedQueryFromUrl, object.query);
	let queryString = exports.stringify(query, options);
	if (queryString) {
		queryString = `?${queryString}`;
	}

	let hash = getHash(object.url);
	if (object.fragmentIdentifier) {
		hash = `#${options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
	}

	return `${url}${queryString}${hash}`;
};

exports.pick = (input, filter, options) => {
	options = Object.assign({
		parseFragmentIdentifier: true,
		[encodeFragmentIdentifier]: false
	}, options);

	const {url, query, fragmentIdentifier} = exports.parseUrl(input, options);
	return exports.stringifyUrl({
		url,
		query: filterObject(query, filter),
		fragmentIdentifier
	}, options);
};

exports.exclude = (input, filter, options) => {
	const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);

	return exports.pick(input, exclusionFilter, options);
};


/***/ }),

/***/ 80500:
/***/ (function(module) {

"use strict";


module.exports = (string, separator) => {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (separator === '') {
		return [string];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [string];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
};


/***/ }),

/***/ 70610:
/***/ (function(module) {

"use strict";

module.exports = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);


/***/ })

}]);